import { Injectable } from '@angular/core';
import { forkJoin, Observable, Observer } from 'rxjs';
import { LazyLoadingService } from '../../misc/service/lazy-loading';

declare var AdyenCheckout: any;

export interface IAdyenPluginOptions {
  adyenOriginKey: string;
  onChange: (state, component) => {};
  brands?: string[];
  locale?: string;
  environment?: string;
  mountPoint: string;
}

@Injectable()
export class AdyenPlugin {

  constructor(private lazyLoading: LazyLoadingService) {
  }

  public load(options: IAdyenPluginOptions): Observable<any> {
    return new Observable<Observer<any>>(obs => {
      forkJoin([
        this.lazyLoading.loadScript('https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.5.0/adyen.js'),
        this.lazyLoading.loadStyle('https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.5.0/adyen.css')
      ]).subscribe((r) => {
        const adyenCheckout = new AdyenCheckout({
          locale: options.locale || 'nl_NL',
          environment: options.environment || 'test',
          originKey: options.adyenOriginKey,
          onChange: (state, component) => options.onChange(state, component)
        });
        // https://docs.adyen.com/payment-methods/cards/custom-card-component
        const customCard = adyenCheckout.create('securedfields', {
          // Optional configuration
          type: 'card',
          brands: options.brands || [ 'mc', 'visa', 'amex', 'bcmc', 'maestro' ],
          styles: {
            base: {
              color: '#3C3C3C',
              fontWeight: '500',
              fontSize: '16px',
              fontSmoothing: 'antialiased',
              fontFamily: 'MuliBold',
              lineHeight: '20px',
              padding: '0',
            },
            error: {
              color: 'red'
            },
            validated: {
              color: 'green'
            },
            placeholder: {
              color: '#d8d8d8',
              fontWeight: '300',
              fontSize: '16px',
              fontSmoothing: 'antialiased',
              fontFamily: 'MuliLight',
            }
          },
          ariaLabels: {
            lang: 'en-GB',
            encryptedCardNumber: {
              label: 'Credit or debit card number field'
            }
          },
          // Events
          onChange: (state, component) => options.onChange(state, component),
          onValid: function () {
          },
          onLoad: function () {
          },
          onConfigSuccess: function () {
          },
          onFieldValid: function () {
          },
          onBrand: function () {
          },
          onError: function () {
          },
          onFocus: function () {
          },
          onBinValue: function () {
          }
        }).mount(options.mountPoint);

        obs.next(adyenCheckout);
      }, (e) => {
        obs.error(e);
      });
    });
  }
}
